// extracted by mini-css-extract-plugin
export default {"info":"Welcome_info__eNWIE","actions":"Welcome_actions__A6lUs"};